<div>

  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.fitting_info.bike" | translate }}:
    </div>
    <div class="col-md-3 label">
      {{bike.Manufacturer}} {{bike.Model}}
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.fitting_info.bike_size" | translate }}:
    </div>
    <div class="col-md-3 label">
      {{bike.BikeSize}}
    </div>
  </div>


  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.fitting_info.goals_for_session" | translate }}:
    </div>
    <div class="col-md-9 label">
      <i *ngIf="!editGoalsOfFitSession">
        <div [innerHTML]="jobcard.GoalsOfFitSession"></div>
        <div class="fa hubtiger-edit font-button" (click)="editGoalsOfFitSession = true"></div>
      </i>
      <div *ngIf="editGoalsOfFitSession">
        <div class="p-inputgroup">
          <textarea [rows]="2" pInputTextarea [(ngModel)]="jobcard.GoalsOfFitSession"></textarea>
          <span class="p-inputgroup-addon" (click)="updateGoalsForFitSession()"><i class="fa fa-check red"></i></span>
        </div>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-3 label">{{ "bikeshop.modal.update_job_card.fitting_info.years_riding" | translate }}:</div>
    <div class="col-md-9 label">
      <i *ngIf="!editYearsOfRiding">
        <div [innerHTML]="fittingInfo.yearsRiding"></div>
        <div class="fa hubtiger-edit font-button" (click)="editYearsOfRiding = true"></div>
      </i>
      <div *ngIf="editYearsOfRiding">
        <div class="p-inputgroup">
          <input type="text" pInputText [(ngModel)]="fittingInfo.yearsRiding"/>
          <span class="p-inputgroup-addon" (click)="updateFittingsInfo(editYearsOfRiding)"><i
            class="fa fa-check red"></i></span>
        </div>
      </div>
    </div>
  </div>


  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.fitting_info.areas_of_discomfort" | translate }}:
    </div>
    <div class="col-md-9 label">
      <i *ngIf="!editAreasOfDiscomfort">
        <div [innerHTML]="fittingInfo.areasOfDiscomfort"></div>
        <div class="fa hubtiger-edit font-button" (click)="editAreasOfDiscomfort = true"></div>
      </i>
      <div *ngIf="editAreasOfDiscomfort">
        <div class="p-inputgroup">
          <textarea [rows]="2" pInputTextarea [(ngModel)]="fittingInfo.areasOfDiscomfort"></textarea>
          <span class="p-inputgroup-addon" (click)="updateFittingsInfo(editAreasOfDiscomfort)"><i
            class="fa fa-check red"></i></span>
        </div>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.fitting_info.injury_history" | translate }}:
    </div>
    <div class="col-md-9 label">
      <i *ngIf="!editInjuryHistory">
        <div [innerHTML]="fittingInfo.injuryHistory"></div>
        <div class="fa hubtiger-edit font-button" (click)="editInjuryHistory = true"></div>
      </i>
      <div *ngIf="editInjuryHistory">
        <div class="p-inputgroup">
          <textarea [rows]="2" pInputTextarea [(ngModel)]="fittingInfo.injuryHistory"></textarea>
          <span class="p-inputgroup-addon" (click)="updateFittingsInfo(editInjuryHistory)"><i
            class="fa fa-check red"></i></span>
        </div>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.fitting_info.riging_goals" | translate }}:
    </div>
    <div class="col-md-9 label">
      <i *ngIf="!editRidingGoals">
        <div [innerHTML]="fittingInfo.ridingGoals"></div>
        <div class="fa hubtiger-edit font-button" (click)="editRidingGoals = true"></div>
      </i>
      <div *ngIf="editRidingGoals">
        <div class="p-inputgroup">
          <textarea [rows]="2" pInputTextarea [(ngModel)]="fittingInfo.ridingGoals"></textarea>
          <span class="p-inputgroup-addon" (click)="updateFittingsInfo(editRidingGoals)"><i
            class="fa fa-check red"></i></span>
        </div>
      </div>
    </div>
  </div>

  <div class="row margin-top-8" *ngIf="fittingInfo.previousFittings && fittingInfo.previousFittings.length > 0">
    <div class="col-md-12 label">
      <div class="carousel-container">
        <p-carousel [value]="fittingInfo.previousFittings"
                    styleClass="carousel" pageLinks="5" [numVisible]="3">
          <ng-template pTemplate="header">
            <div
              class="p-carousel-header-title">{{ 'bikeshop.modal.update_job_card.fitting_info.previous_fittings' | translate }}
              ({{fittingInfo.previousFittings.length}})
            </div>
          </ng-template>
          <ng-template let-fitting pTemplate="item">
            <div class="record alt"
                 [ngClass]="{ 'clickable' : fitting.partnerID == partnerID && fitting.id !== jobcard.ID, 'non-clickable': fitting.partnerID !== partnerID || fitting.id === jobcard.ID }"
                 (click)="openJobcard(fitting)">
              <div class="title"><b>{{fitting.jobcardID}}</b><span class="fa fa-fw fa-check-square"
                                                                   *ngIf="fitting.fittingDate"></span></div>
              <div class="record-row">
                <div class="label">{{ 'bikeshop.modal.shared.bike.shop' | translate }}:</div>
                <div class="value">{{ fitting.shopName }}</div>
              </div>
              <div class="record-row">
                <div class="label">{{ 'bikeshop.modal.update_job_card.fitting_info.fitting_date' | translate }}:</div>
                <div class="value">{{ fitting.fittingDate | date : countryData.AngularDateFormat }}</div>
              </div>
              <div class="record-column margin-top-8">
                <div
                  class="label">{{ 'bikeshop.modal.update_job_card.fitting_info.goals_for_previous_session' | translate }}
                  :
                </div>
                <div class="value">{{ fitting.goalsOfFitSession }}</div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>


</div>
